import { render, staticRenderFns } from "./administrators.vue?vue&type=template&id=66efe9f8&"
import script from "./administrators.vue?vue&type=script&lang=js&"
export * from "./administrators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports